const labels = {
  productAndOffers: 'Products & Offers',
  accounts: 'Accounts',
  referrals: 'Referrals',
}

export { labels }
